import { render, staticRenderFns } from "./signature.vue?vue&type=template&id=2f1ed698&scoped=true&"
import script from "./signature.vue?vue&type=script&lang=js&"
export * from "./signature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1ed698",
  null
  
)

export default component.exports